import { Box } from "@stenajs-webui/core";
import {
  NavBarSearchField,
  type NavBarSearchFieldProps,
} from "@stenajs-webui/panels";
import { type FC, type RefObject, useEffect, useRef } from "react";

import { MAXIMUM_SEARCH_LENGTH } from "../../../../common/graphql/useSearchBookingsResult";

export const WRAPPER_CLASS_NAME = "booking-search-wrapper";

interface BookingSearchInputProps extends NavBarSearchFieldProps {
  hasFocus: boolean;
  onClickClear: () => void;
  onClickSearch: () => void;
  onEsc: () => void;
  onFocus: () => void;
  onValueChange: (value: string) => void;
  ref?: RefObject<HTMLDivElement>;
  value: string;
}

export const BookingSearchInput: FC<BookingSearchInputProps> = ({
  hasFocus,
  onClickClear,
  onClickSearch,
  onEsc,
  onFocus,
  onValueChange,
  value,
  ref,
  ...props
}: BookingSearchInputProps) => {
  // TODO: Maybe remove this useEffect
  useEffect(() => {
    if (hasFocus) {
      inputRef.current?.focus();
    } else {
      inputRef.current?.blur();
    }
  }, [hasFocus]);

  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <Box flex={1} ref={ref}>
      <NavBarSearchField
        placeholder={"Search bookings"}
        showClearButton={hasFocus}
        onClickClearButton={() => {
          onClickClear();
          inputRef?.current?.focus();
        }}
        inputRef={inputRef}
        onValueChange={onValueChange}
        onFocus={onFocus}
        value={value}
        onEnter={onClickSearch}
        onEsc={onEsc}
        wrapperClassName={WRAPPER_CLASS_NAME}
        maxLength={MAXIMUM_SEARCH_LENGTH}
        {...props}
      />
    </Box>
  );
};
